module.exports = __webpack_public_path__ + "img/sponsors-04.f0480419.png";